import { render, staticRenderFns } from "./OnePagerPolicy.vue?vue&type=template&id=49138c84&scoped=true"
import script from "./OnePagerPolicy.vue?vue&type=script&lang=js"
export * from "./OnePagerPolicy.vue?vue&type=script&lang=js"
import style0 from "./OnePagerPolicy.vue?vue&type=style&index=0&id=49138c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49138c84",
  null
  
)

export default component.exports